import {
  OtherGroundProductsThanCementClassificationInputNames,
  MaterialType
} from '@domain/materials'
import {dataTestId} from '@hconnect/uikit'
import {useFormContext} from 'react-hook-form'

import {useMaterialsClassificationMetadata} from '../../../hooks'
import {MaterialFormDefaultValues} from '../../materials-details/ExistingMaterialDetails/hooks'
import {MaterialsGrid} from '../components/MaterialsGrid'
import {MaterialsGridItem} from '../components/MaterialsGridItem'

import {ClassificationAutocomplete} from './inputs/ClassificationAutocomplete'
import {ClassificationCheckBox} from './inputs/ClassificationCheckbox'
import {ClassificationTextField} from './inputs/ClassificationTextField'

interface OtherGroundProductsThanCementClassificationProps {
  isDisabled: boolean
}

export const OtherGroundProductsThanCementClassification: React.FC<
  OtherGroundProductsThanCementClassificationProps
> = ({isDisabled}) => {
  const {data: metadata} = useMaterialsClassificationMetadata(
    MaterialType.OtherGroundProductsThanCement
  )

  useFormContext<MaterialFormDefaultValues>()
  if (!metadata) {
    throw new Error(
      'BUG: classification metadata should be loaded before rendering classification tab'
    )
  }

  return (
    <MaterialsGrid {...dataTestId('OtherGroundProductsThanCement_classification_form')}>
      <MaterialsGridItem>
        <ClassificationAutocomplete
          materialType={MaterialType.OtherGroundProductsThanCement}
          inputName={OtherGroundProductsThanCementClassificationInputNames.Category}
          metadata={metadata}
          isDisabled={isDisabled}
        />
      </MaterialsGridItem>
      <MaterialsGridItem>
        <ClassificationCheckBox
          materialType={MaterialType.OtherGroundProductsThanCement}
          inputName={OtherGroundProductsThanCementClassificationInputNames.IntermediateMillProduct}
          customValues={{trueValue: 'Yes', falseValue: 'No'}}
          metadata={metadata}
          isDisabled={isDisabled}
        />
      </MaterialsGridItem>
      <MaterialsGridItem>
        <ClassificationAutocomplete
          materialType={MaterialType.OtherGroundProductsThanCement}
          inputName={
            OtherGroundProductsThanCementClassificationInputNames.ReferenceMeshSizeForResidue
          }
          metadata={metadata}
          isDisabled={isDisabled}
        />
      </MaterialsGridItem>
      <MaterialsGridItem>
        <ClassificationTextField
          materialType={MaterialType.OtherGroundProductsThanCement}
          inputName={OtherGroundProductsThanCementClassificationInputNames.LegacyId}
          metadata={metadata}
          isDisabled={isDisabled}
        />
      </MaterialsGridItem>
    </MaterialsGrid>
  )
}
